module.exports = __webpack_public_path__ + "img/master-card.5d025b74.svg";